import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Spacing from '@marvelapp/marvel-ui/spacing';
import Heading from '@marvelapp/marvel-ui/heading';
import Align from '@marvelapp/marvel-ui/align';
import Paragraph from '@marvelapp/marvel-ui/paragraph';

import Image from 'marketing-website/components/modules/Image';
import SmartLink from 'marketing-website/components/modules/SmartLink';

export default class LabCard extends Component {
  constructor() {
    super();

    this.state = {
      isHovered: false,
    };
  }

  onMouseOver = () => {
    this.setState({ isHovered: true });
  };

  onMouseOut = () => {
    this.setState({ isHovered: false });
  };

  render() {
    const { description, name, url, asset, category } = this.props;
    const hoverTitleColor = this.state.isHovered ? 'slate' : 'black';
    const opacityClass = cx('transitionDuration-m', {
      'opacity-80': this.state.isHovered,
      'opacity-100': !this.state.isHovered,
    });
    return (
      <div onMouseOver={this.onMouseOver} onMouseOut={this.onMouseOut}>
        <SmartLink url={url}>
          <Align type="center" typeM="left">
            <div className={opacityClass}>
              <Image {...asset} />
            </div>
            <Spacing type="padding" size="m" position="topBottom">
              <Spacing type="padding" size="xs" position="bottom">
                <Heading tag="div" size="m" weight="semibold" color="silver">
                  {category && category.name}
                </Heading>
              </Spacing>
              <Spacing type="padding" size="xs" position="bottom">
                <Heading
                  tag="h3"
                  weight="semibold"
                  size="xxl"
                  color={hoverTitleColor}
                >
                  {name}
                </Heading>
              </Spacing>
              <Paragraph size="l">
                <span className="whiteSpace-normal truncateText-two">
                  {description}
                </span>
              </Paragraph>
            </Spacing>
          </Align>
        </SmartLink>
      </div>
    );
  }
}

LabCard.propTypes = {
  description: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  asset: PropTypes.node.isRequired,
  category: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./src/pages/labs/card.js